
/* styles */
require("!!vue-style-loader!css-loader!../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-7ffe1f52\",\"scoped\":true,\"hasInlineConfig\":false}!postcss-loader!sass-loader!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Trip.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Trip.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-7ffe1f52\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Trip.vue"),
  /* scopeId */
  "data-v-7ffe1f52",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/admin/Trip.vue
// module id = 598
// module chunks = 1